import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["fill", "height", "width"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M30.2619 10.3333L70.9714 10.3333C72.804 10.3333 74.5772 10.9827 75.9764 12.1662L100.588 32.9837C102.329 34.4562 103.333 36.6207 103.333 38.9009L103.333 103.764C103.333 113.015 103.228 113.667 93.7381 113.667L30.2619 113.667C20.7723 113.667 20.6667 113.015 20.6667 103.764L20.6667 20.2361C20.6667 10.985 20.7723 10.3333 30.2619 10.3333Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    viewBox: "0 0 124 124",
    fill: _ctx.color,
    height: _ctx.size,
    width: _ctx.size,
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  }, _hoisted_3, 8, _hoisted_1))
}